




















































































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import 'vue-datetime/dist/vue-datetime.css';

export default Vue.extend({
  components: {
    pxButton,
    pxCard,
  },

  data() {
    return {
      creating: true,
      pushingClassroom: false,
      currentCoursePage: 0,
      numberOfCoursesToShow: 200,
    };
  },

  computed: {
    ...mapState({
      courses: (state: any) => state.courses.courses,
      descomplicaCourses: (state: any) => state.descomplica.courses,
    }),

    ...mapGetters({
      classroom: 'currentClassroom',
    }),
  },

  async created() {
    this.creating = this.$route.name === 'classroom_create';
    if (this.creating) {
      this.$store.commit('SET_EMPTY_CLASSROOM');
    } else {
      let classroomId = parseInt(this.$route.params.classroomId);
      await this.$store.dispatch('PULL_CLASSROOM', classroomId);
      //TODO no classroom found
    }
    await this.$store.dispatch('PULL_DESCOMPLICA_COURSES');
    await this.$store.dispatch('PULL_COURSES', {
      currentPage: this.currentCoursePage,
      numberOfCoursesToShow: this.numberOfCoursesToShow,
    });
  },

  methods: {
    pushClassroom: async function() {
      //TODO valid classroom
      if (this.classroom.course != null && this.pushingClassroom === false) {
        this.pushingClassroom = true;
        this.classroom.isBonus = !this.classroom.isBonus ? false : true;

        await this.$store.dispatch('PUSH_CLASSROOM', this.classroom);
        this.pushingClassroom = false;
        //TODO error inputing classroom
        if (this.classroom.id) {
          if (this.creating) {
            this.$router.push(`/turma/${this.classroom.id}`);
          } else {
            this.$router.push(`/turma/${this.classroom.id}`);
          }
        }
      } else {
        alert('Escolha um curso para essa turma!');
      }
    },
    goHome() {
      this.$router.push('/');
    },
  },
});
